module.exports = __webpack_public_path__ + "img/bf6689bcd3-bfm-tv-logo-bfmtv-logo-force-media.26fd5834.png";